import styled from '@emotion/styled';
import { theme } from 'ui-components';

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${theme.space['spacing-200']};
`;

export const ItemContainer = styled.div``;
